module.exports = __webpack_public_path__ + "er.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/er.svg
// module id = 790
// module chunks = 0